// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__7SRo-","error":"Textarea_error__3CU5d","readonly":"Textarea_readonly__25r_T","disabled":"Textarea_disabled__3WrKF"};